import { Auth2Fa } from '@/features/2fa/components/Auth2Fa';

export default function Page2Fa() {
  return <Auth2Fa />;
}
